import { Box } from '@mui/system';
import React from 'react';

interface KuwaitiDinarFormatProps {
  amount: number;
}

const formatAmountWithWesternNumerals = (amount: number) => {
  const formattedAmount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(amount);

  return formattedAmount;
};

const KuwaitiDinarFormat: React.FC<KuwaitiDinarFormatProps> = ({ amount }) => {
  const formattedAmount = formatAmountWithWesternNumerals(amount);

  return <Box>{formattedAmount} KD</Box>;
};

export default KuwaitiDinarFormat;